import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import { RoadmapTypes } from '../../roadmap.constants';

export const StyledUpgradeToPremiumContainer = styled.div<{ selectedRoadmap?: string }>`
  width: 100%;
  background: linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%);
  border-radius: 0.5rem;
  padding: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: ${({ selectedRoadmap }) => selectedRoadmap === RoadmapTypes.PREMIUM_ROADMAP && '5rem'};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 85rem;
  }
`;

export const StyledInfoBar = styled.p`
  background: #719cf933;
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #f9f9fb;
    margin-bottom: 0;
    font-size: 2.4rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    h2 {
      font-size: 2.4rem;
    }
  }
`;
export const StyledFeatureCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 1rem;
  > div {
    width: calc(25% - 1rem);
    h2 {
      margin-bottom: 1rem;
    }
    background: #1c2538;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    > div {
      width: calc(50% - 0.5rem);
      height: 30rem;
      padding-top: 1.6rem;
      h2 {
        margin-bottom: 1rem;
      }
    }
  }
`;

export const StyledInfoIcon = styled(FontAwesomeIcon)`
  margin-right: 1rem;
  color: #ff5b67;
`;

export const StyledUpgradeToPremiumTitleContainer = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  gap: 0.4rem;
  h2:nth-child(2) {
    color: #a3ea2a;
  }
`;

export const StyledRightGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  button {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: auto;
    flex-direction: row;
    align-items: center;
  }
  button {
    width: auto;
  }
`;
